export function scrollToTopSetup(){
    let visible = false;
    let scrollBtn =  document.querySelector("#ScrollToTop");
    let scrollWrapper =  document.querySelector("#ScrollWrapper");
    
    scrollBtn.addEventListener('click', ()=>{
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    document.addEventListener("scroll", (event) => {
        if(window.scrollY > window.innerHeight){
            scrollWrapper.classList.remove('opacity-0');
        }else{
            scrollWrapper.classList.add('opacity-0');
        }

    });
}